import React from 'react'
import {
  Button,
  ButtonSentiment,
  ButtonSize,
  buttonStyles,
} from 'sidecar-components/atoms/Button'
import { Icon, IconSize } from 'sidecar-components/atoms/Icon'
import { GenericLinkComponent } from './PreCheckedProviders.types'

interface LearnMoreButtonProps {
  /** Icon name to display */
  icon?: string
  /** Test ID for testing purposes */
  testId: string
  /** Button sentiment/style */
  sentiment?: ButtonSentiment
  /**
   * Link component to use for external links (Next.js Link, React Router Link,
   * etc.)
   */
  linkComponent?: GenericLinkComponent
}

export const LearnMoreButton: React.FC<LearnMoreButtonProps> = ({
  icon = '',
  testId,
  sentiment = ButtonSentiment.SECONDARY_ON_COLOR,
  linkComponent,
}) => {
  // Icon size mapping for consistent sizing
  const iconSizeMap = {
    [ButtonSize.LARGE]: IconSize.MD,
    [ButtonSize.MEDIUM]: IconSize.SM,
    [ButtonSize.SMALL]: IconSize.XS,
  }

  const path = '/help/accessing-your-health-plan/what-are-pre-checked-providers'

  // If linkComponent is provided, use it instead of Button to avoid next.js router dependency
  if (linkComponent) {
    const LinkComponent = linkComponent
    return (
      <LinkComponent
        href={path}
        className={buttonStyles({
          busy: false,
          children: 'Learn more',
          disabled: false,
          icon,
          sentiment,
          size: ButtonSize.MEDIUM,
          width: 'flex',
        })}
        data-testid={`btn_learnMore_${testId}`}
      >
        <span className="truncate">Learn more</span>
        {icon && (
          <Icon
            name={icon}
            size={iconSizeMap[ButtonSize.MEDIUM] || IconSize.SM}
          />
        )}
      </LinkComponent>
    )
  }

  return (
    // Fall back to Button when no linkComponent is provided
    <Button
      testId={`btn_learnMore_${testId}`}
      icon={icon}
      iconPosition="after"
      path={path}
      sentiment={sentiment}
    >
      Learn more
    </Button>
  )
}
